export default __webpack_public_path__ + "static/media/two-setting.b69d4208.svg";